import Title from '../../components/Title';

export default function SectionJoin () {

    const GoToMembership = () => {
        window.location.href = "/membership"
    }

    return (
        <section className="bg-white text-[#1E2332]">
            <div className="lg:max-w-[82rem] lg:mx-auto">
                <div className="lg:mt-16 pb-2 flex lg:flex-row flex-col lg:justify-between lg:items-center bg-slate-200 join-section">
                    <div className="lg:w-2/3 lg:p-12 p-4">
                        <Title title='Looking for member benefits?' />
                        <p className="lg:text-[18px] text-[15px] lg:pt-4 pt-2">
                        Unlock the Power of Community: Join the New Rochelle Council of Community Services Today and Make a Difference That Matters!
                        </p>
                    </div>  

                    <div className="lg:p-12 px-4 gap-4 pb-4 flex lg:flex-col">
                        <button onClick={GoToMembership} className="font-malaya lg:text-xl text-sm bg-[#1E2332] border border-[#1E2332] lg:py-2.5 lg:w-30 w-28 py-1.5 group relative">
                        
                            <div class="absolute inset-0 w-0 bg-slate-50 transition-all duration-300 ease-out group-hover:w-full"></div>
                            <span className="relative text-slate-50 group-hover:text-[#1E2332] uppercase text-sm font-bold">
                                Join
                            </span>
                            
                        </button>

                        <button onClick={GoToMembership} className="font-malaya lg:text-xl text-sm border border-[#1E2332] lg:py-2.5 lg:w-30 w-28 py-1.5 group relative">
                        
                            <div class="absolute inset-0 w-0 bg-yellow-400 transition-all duration-300 ease-out group-hover:w-full"></div>
                            <span className="relative text-[#1E2332] uppercase text-sm font-bold">
                                Benefits
                            </span>
                            
                        </button>
                    </div>
                </div>
            </div>  
        </section>
    )
}